const translations = {
        "az":{
            home:"ANA SƏHİFƏ",
            product:"ƏTİRLƏR",
            about:"HAQQIMIZDA",
            blog:"BLOQ",
            contact:"BİZİMLƏ ƏLAQƏ" ,
            wishlist:"İSTƏK SİYAHISI",
            emptywishlist:"İstək siyahınız boşdur.",
            cart:"Səbət",
            total:"Ümumi Məbləğ",
            emptycart:"Səbətiniz boşdur.",
            order:"SİFARİŞ",
            cartitems:"Səbətinizdəki məhsullar",
            productName:"Məhsul",
            productName1:"Məhsulun adı",
            quantity:"Miqdar",
            price:"Qiymət",
            view:"Baxış",
            delete:"Sil",
            readMore:"Daha ətraflı",
            addToCart:"Səbətə əlavə et",
            address:"Ünvan",
            phone:"Telefon",
            email:"E-poçt",
            copyright:"Bütün hüquqlar qorunur.",
            man:"Kişi ətirləri",
            woman:"Qadın ətirləri",
            unisex:"Unisex ətirlər",
            brand:"Brendlər",
            all:"Hamısı",
            category:"Kateqoriyalar",
            dis:"ENDİRİM",
            brand1:"Brend",
            volume:"Həcm",
            accord:"Akkord",
            accord1:"Akkordlar",
            min:"Min",
            max:"Maks",
            not:"Notlar",
            readMore:"Daha çox",
            ml:"ML",
            sort:"Sırala:",
            desc:"Təsvİr",
            pdetails:"Xüsusİyyətlərİ",
            reviews:"Rəylər",
            order:"Sİfarİş",
            billing:"Ödəniş Təfərrüatları",
            firstName:"Ad",
            lastName:"Soyad",
            phone:"Mobil",
            email:"E-poçt",
            delivery:"Çatdırılma üsulu :",
            radio1:"Mağazadan əldə etmək",
            radio2:"Ünvana çatdırılma",
            radioinput:"Ünvan",
            orderNote:"Sifariş notu",
            orderP:"Sifarişiniz haqqında qeydlər, məs. çatdırılma üçün xüsusi qeydlər.",
            product1:"Məhsul",
            allTotal:"Sifariş cəmi",
            lastOrder:"Sİfarİşİ təsdİqləyİn",
            yourOrder:"Sifarişiniz",
            sort1:"A-Z",
            sort2:"Z-A",
            sort3:"Qiymət (Aşağı > Yuxarı)",
            sort4:"Qiymət (Yuxarı > Aşağı)",
            result:"Nəticə",
            view:"Görünüş",
            about1:"haqqımızda",
            loading:"Yüklənir...",
            search:"Axtarış...",
            notfound:"Məhsul tapılmadı",
            contactAddress:"Çinar Plaza, Heydər Əliyev Prospekti, Bakı, Azərbaycan",
            dis1:"ENDİRİMLƏR",
            aboutTitle:"MyPerfume MMC ətir, odekolon və ətirlə bağlı məhsulların alqı-satqısı üzrə İxtisaslaşmışdır.",
            aboutDesc:"Biz – 2018-ci ildən etibarən sevgi və diqqətlə sizin üçün çalışan bir şirkətik ki, hər bir müştəri yalnız keyfiyyətli məhsulları deyil, eyni zamanda etibarınıza layiq xidməti tapsın. İlk günlərdən etibarən yalnız təcrübəli mütəxəssisləri komandamıza dəvət edərək müştərilərimizə yüksək səviyyəli xidmət təqdim edirik. </br> </br> Yalnız rəsmi təchizatçılarla işləyərək, bəyəndiyiniz hər bir məhsul haqqında məlumatın tam şəffaflığını və etibarlılığını təmin edirik. Yalnız tanınmış dünya markalarından olan orijinal ətirlər – ruhlandıran və heyran edən hər şey məhz burada! </br> </br> Müştərilərimizə olan xüsusi münasibətimiz bizə Azərbaycan bazarının ehtiyaclarını daha yaxşı başa düşməyə kömək edir. Sizin inamınız və dəstəyiniz sayəsində hər zaman Azərbaycana aktual və dəbli məhsullar gətiririk. Biz sizinlə birgə ətir modasını formalaşdırır və hər birinin üslubunu və fərdiliyini vurğulayırıq. </br> </br> Sizin seçiminiz bizi ətir dünyasında yeni zirvələri fəth etməyə ruhlandırır və hər gün daha yaxşı, sizə daha yaxın və daha dəyərli olmaq istəyi bəxş edir. Bizimlə olduğunuz üçün təşəkkür edirik!",
            searchResult:"Axtarış nətİcəsİ :",
            about2:"Haqqımızda",
            contact1:"Bizimlə əlaqə",
            addToCart1:"Əlavə edİlİb",
            terms:"Şərtlər və qaydalar",
            terms1:"Təhlükəsizlik siyasəti",
            terms2:"Təhlükəsİzlİk sİyasətİ",
            allBrand:"Bütün Brendlər",
            payment:"Ödəmə üsulunu seçin :",
            payment1:"Nağd ödəniş",
            payment2:"Online ödəniş",
            payment3:"TAM ÖDƏNİŞ",
            payment4:"Sayta özəl Taksit kart ilə ödəniş",
            payment5:"ay",
            orderSuccess:"Sifarişiniz qeydə alındı.",
            welcome:"Xoş gəlmİsİnİz !",
            promoSuccess:"Promo kod tətbiq edildi ",
            promoClick:"Tətbiq et",
            promoDis:"Endirimi əldə etmək üçün promo kodu qeyd edin.",
            promoErr:"Promo kod düzgün deyil.",
            original:"Orijinal Ətirlər",
            hours:"İş saatları",
            express:"Express təhvil alma",
            filial1:"Anbar (Express)",
            filial2:"MyShops Gənclik Mall filialı",
            filial3:"MyShops Crescent Mall filialı",
            filial4:"MyShops Bülbül filialı",
            filial5:"MyShops Sumqayıt filialı",
            addFilial:"Anbar (Ulduz metrosunun çıxışı)",
            addFilial1:"Gənclik mall, mərtəbə -1",
            addFilial2:"Crescent mall, mərtəbə 3",
            addFilial3:"Bülbül prospekti 38a",
            addFilial4:"Sumqayıt şəhəri, Üzeyir Hacıbəyov küçəsi 2",
            during:"Gün ərzində",
            promoErr1:"Promo kodun istifadə müddəti bitib.",
            disResult:"məhsul bitənə qədər",
            say:"Məhsul bİtİb",
            disTitle:"Yeni ətir, böyük endirim !",
            searchFilter:"Filtr üzrə axtar",
            notResult:"Axtarış nətİcəsİ tapılmadı :",
            notResultDesc:"Lakin, aşağıdakı parfüm kolleksiyaları sizin zövqünüzə və tələblərinizə uyğun ola bilər.",
            oneClick:"BİR KLİKLƏ AL",
             termsDesc:"<p> Azərbaycan Respublikasının qüvvədə olan qanunvericiliyinə əsasən, parfümeriya və kosmetika məhsulları keyfiyyətli olduqda geri qaytarıla və ya dəyişdirilə bilməz. Bu qayda, şəxsi gigiyena və təhlükəsizlik səbəbləri ilə əlaqədar olaraq tətbiq edilir.</p>  </br>  <p>Lakin aşağıdakı hallarda məhsulun geri qaytarılması və ya dəyişdirilməsi mümkündür:  </p> </br> <ol><li> <strong> *Zavod qüsuru*</strong> – Məhsul istehsal qüsuru ilə təqdim edilibsə, müştəri onu geri qaytara və ya eyni məhsulla dəyişdirə bilər.</li> </br>  <li> <strong> *Yanlış məhsul göndərilməsi*</strong>– Sifariş verilən məhsuldan fərqli bir məhsul göndərildikdə, həmin məhsul orijinal qablaşdırmada və istifadə olunmamış halda geri qaytarıla bilər.</li> </br>  <li> <strong> *Məhsulun yararlılıq müddətinin bitməsi*</strong> – Alındığı zaman istifadə müddəti başa çatmış məhsulların geri qaytarılması mümkündür.</li>  </ol> </br> <p> Geri qaytarma və dəyişdirmə üçün aşağıdakı şərtlər yerinə yetirilməlidir:</p>  </br> <ul><li> Məhsul orijinal qablaşdırmada və istifadə olunmamış vəziyyətdə olmalıdır. </li> </br> <li>Alış haqqında qəbz və ya elektron faktura təqdim edilməlidir.</li> </br> <li>Geri qaytarma və ya dəyişdirmə üçün müraciət alış tarixindən etibarən <strong>*14 gün*</strong> ərzində edilməlidir.</li></ul> </br> <p> Məhsulun geri qaytarılması və ya dəyişdirilməsi ilə bağlı əlavə suallarınız yaranarsa, bizimlə əlaqə saxlaya bilərsiniz.   </p>  </br>   <p> <strong>*Qeyd:*</strong>  Qanunvericiliyin tələblərinə uyğun olaraq, geri qaytarma siyasətimiz müvafiq qaydalar və normativ aktlara əsaslanır və istənilən vaxt dəyişdirilə bilər. </p>",
             privacyDesc:"<p>Biz müştərilərimizin şəxsi məlumatlarının və ödəniş məlumatlarının təhlükəsizliyini təmin etməyə böyük önəm veririk. Saytımızda aparılan bütün əməliyyatlar və məlumat ötürmələri müasir təhlükəsizlik standartlarına uyğun qorunur.  </p> </br> <p><strong>Məlumatların Mühafizəsi</strong></p> </br>     <ul><li>Saytımızda toplanan şəxsi məlumatlar (ad, soyad, əlaqə nömrəsi, e-poçt və s.) üçüncü şəxslərlə paylaşılmır və yalnız xidmətlərin göstərilməsi məqsədilə istifadə edilir.</li> </br> <li>Ödəniş zamanı daxil edilən məlumatlar SSL şifrələmə texnologiyası vasitəsilə qorunur və birbaşa sertifikatlaşdırılmış ödəniş sistemləri tərəfindən emal olunur.</li></ul>  </br>    <p><strong> İstifadəçi Məsuliyyəti </strong></p> </br> <ul><li>İstifadəçilər hesab məlumatlarını (istifadəçi adı, parol) üçüncü şəxslərlə paylaşmamalıdır.</li> </br> <li>Şübhəli fəaliyyət aşkarladığınız halda, dərhal bizimlə əlaqə saxlayın.</li></ul> </br> <p><strong>Cookies və Analitika </strong></p> </br> <ul><li>Saytımızın funksionallığını artırmaq və istifadəçi təcrübəsini yaxşılaşdırmaq məqsədilə Cookies-dən istifadə edirik.</li> </br> <li>Cookies-dən imtina etmək və ya parametrləri dəyişmək üçün brauzer ayarlarınızı tənzimləyə bilərsiniz.</li></ul> </br> <p><strong>*Dəyişikliklər və Yeniləmələr* </strong></p> </br>    <p>Təhlükəsizlik siyasətimiz Azərbaycan Respublikasının qüvvədə olan qanunvericiliyinə uyğun olaraq mütəmadi olaraq yenilənə bilər. Yeniliklər barədə məlumat almaq üçün bu səhifəni mütəmadi yoxlamağınızı tövsiyə edirik.  </p> </br>   <p>Əlavə suallarınız yaranarsa, bizimlə əlaqə saxlaya bilərsiniz.</p>",
             cookieDesc:'Vebsaytımız, istifadəçi təcrübəsini yaxşılaşdırmaq məqsədilə kukilərdən istifadə edir. Kukilərdən istifadəyə razılığınızı bildirmək üçün "Qəbul et" düyməsini basın, əks halda "İmtina et" seçin. Daha ətraflı   məlumat üçün <a href="/privacypolicy"> Təhlükəsizlik siyasəti</a> səhifəsini oxumağınızı    tövsiyə edirik.',
             accept:"Qəbul et",
             reject:"İmtina et",
             mart:"8 MART",
             martDesc:"Sizin üçün ən gözəl ətirlər burada !",
             explore:"KƏŞF ET",
             newProducts:"YENİ MƏHSULLAR",

             bannerMan:"Kİşİ ətİrlərİ",
             bannerWoman:"Qadın ətİrlərİ",

             review:"Rəy bildir",
             mehsuluqiymetlendir:"Məhsulu qiymətləndir:",
             gonder:"Göndər",
             mesajiniz:"Mesajınız",
             star:"Ulduz" ,

             ilkRey: "İlk rəy sizdən olsun </br> – ulduzlar sizi gözləyir!",


             catdirilmaUnvan:"Çatdırılma Ünvanı",
             inputP:"Çatdırılma ünvanını qeyd edin",

            
            
            

        },




        "en":{
            home:"HOME",
            product:"PERFUMES",
            about:"ABOUT",
            blog:"BLOG",
            contact:"CONTACT US",
            wishlist:"WISHLIST",
            emptywishlist:"Your wish list is empty.",
            cart:"Cart",
            total:"Total amount",
            emptycart:"Your cart is empty.",
            order:"Order",
            cartitems:"Products in your cart",
            productName:"Product",
            productName1:"Product name",
            quantity:"Quantity",
            price:"Price",
            view:"View",
            delete:"Remove",
            readMore:"See more",
            addToCart:"Add to cart",
            address:"Address",
            phone:"Phone",
            email:"Email",
            copyright:"All Rights Reserved.",
            man:"Perfumes for men",
            woman:"Perfumes for women",
            unisex:"Unisex perfumes",
            brand:"Brands",
            all:"All",
            category:"Categories",
            dis:"DISCOUNT",
            brand1:"Brand",
            volume:"Volume",
            accord:"Accord",
            accord1:"Accords",
            min:"Min",
            max:"Max",
            not:"Notes",
            readMore:"More",
            ml:"ML",
            sort:"Sort by:",
            desc:"Description",
            pdetails:"CHARACTERISTICS",
            reviews:"Reviews",
            order:"Order",
            billing:"Billing Details",
            about1:"about",
            
            firstName:"First Name",
            lastName:"Last Name",
            phone:"Phone",
            email:"E-mail",
            delivery:"Delivery method :",
            radio1:"Get it from the store",
            radio2:"Delivery to the address",
            radioinput:"Address",
           
            orderNote:"Order note",
            orderP:"Notes about your order, e.g. special notes for delivery.",
            product1:"Product",
            lastOrder:"Confirm the order",
            yourOrder:"Your order",
            sort1:"A-Z",
            sort2:"Z-A",
            sort3:"Price (Low > High)",
            sort4:"Price (High > Low)",
            result:"Result",
            view:"View",
            loading:"Loading...",
            search:"Search...",
            notfound:"Product not found",
            contactAddress:"Chinar Plaza, Heydar Aliyev Avenue, Baku, Azerbaijan",
            dis1:"DISCOUNTS",
            aboutTitle:"MyParfumes LLC specializes in buying and selling perfume, cologne and fragrance-related products.",
            aboutDesc:"We are a company that, since 2018, has been working with love and attention for you, so that every customer finds not only high-quality products but also service worthy of your trust. From day one, we have invited only experienced specialists to our team to provide our clients with the highest level of service. </p> </br> By working exclusively with official suppliers, we guarantee complete transparency and reliability of information about each product you like. Only original perfumes from renowned global brands – everything to captivate and inspire. </br> </br> Our special approach to our customers helps us understand the needs of the Azerbaijani market better. Thanks to your trust and support, we always bring trendy and sought-after products to Azerbaijan, keeping up with the peak of the perfume world. Together with you, we shape fragrance trends and create a unique style that highlights everyone’s individuality. </br> </br> Your choice inspires us to conquer new heights in the perfume world and gives us the drive to become better, closer, and more valuable to you every day. Thank you for being with us!",
            searchResult:"Search result :",
            about2:"About",
            contact1:"Contact us",
            addToCart1:"Added",
            terms:"Terms and conditions",
            terms1:"Security policy",
            terms2:"Security policy",
            allBrand:"All Brands",
            payment:"Choose Payment Method :",
            payment1:"Cash Payment",
            payment2:"Online Payment",
            payment3:"Full Payment",
            payment4:"Installment Payment with Site-Specific Card",
            payment5:"mo",
            orderSuccess:"Your order has been registered.",
            welcome:"Welcome !",
            promoSuccess:"Promo code applied ",
            promoClick:"Apply",
            promoDis:"Enter the promo code to get the discount.",
            promoErr:"The promo code is incorrect.",
            original:"Original Perfumes",
            hours: "Working hours",
            express: "Express delivery",
            filial1: "Warehouse (Express)",
            filial2: "MyShops Gənclik Mall branch",
            filial3: "MyShops Crescent Mall branch",
            filial4: "MyShops Bülbül branch",
            filial5: "MyShops Sumqayıt branch",
            addFilial: "Warehouse (Ulduz metro station exit)",
            addFilial1: "Gənclik mall, floor -1",
            addFilial2: "Crescent mall, floor 3",
            addFilial3: "Bülbül prospekti 38a",
            addFilial4: "Sumqayıt city, Üzeyir Hacıbəyov street 2",
            during: "Throughout the day",
            promoErr1:"The promo code has expired.",
            disResult:"until the product is finished",
            say:"The product is out of stock.",
            disTitle:"New perfume, big discount!",
            searchFilter:"Search by filter",
            notResult:"Search results not found :",
            notResultDesc:"However, the following perfume collections may suit your taste and preferences.",
            oneClick:"Buy with one click",
            termsDesc: "<p> According to the legislation in force in the Republic of Azerbaijan, perfumery and cosmetic products cannot be returned or exchanged if they are of good quality. This rule is applied due to personal hygiene and safety reasons. </p>  </br>  <p> However, in the following cases, the product can be returned or exchanged:  </p> </br> <ol><li> <strong> *Factory defect*</strong> – If the product is presented with a manufacturing defect, the customer can return or exchange it with the same product.</li> </br>  <li> <strong> *Wrong product delivery*</strong> – If a product different from the one ordered is sent, it can be returned in its original packaging and unused condition.</li> </br>  <li> <strong> *Expiration of product shelf life*</strong> – Products with an expired shelf life at the time of purchase can be returned.</li>  </ol> </br> <p> To return or exchange a product, the following conditions must be met:</p>  </br> <ul><li> The product must be in its original packaging and unused condition. </li> </br> <li>A receipt or electronic invoice of the purchase must be provided.</li> </br> <li>The return or exchange request must be made within <strong>*14 days*</strong> from the date of purchase.</li></ul> </br> <p> If you have additional questions regarding the return or exchange of a product, you can contact us. </p>  </br>   <p> <strong>*Note:*</strong> In accordance with the requirements of the legislation, our return policy is based on relevant rules and normative acts and may be changed at any time. </p>",
            privacyDesc: "<p>We prioritize ensuring the security of our customers' personal and payment information. All transactions and data transmissions on our website are protected in accordance with modern security standards. </p> </br> <p><strong>Data Protection</strong></p> </br> <ul><li>Personal information collected on our website (name, surname, contact number, email, etc.) is not shared with third parties and is used solely for the purpose of providing services.</li> </br> <li>Information entered during payment is protected by SSL encryption technology and is processed directly by certified payment systems.</li></ul> </br> <p><strong>User Responsibility</strong></p> </br> <ul><li>Users should not share their account information (username, password) with third parties.</li> </br> <li>If you detect any suspicious activity, please contact us immediately.</li></ul> </br> <p><strong>Cookies and Analytics</strong></p> </br> <ul><li>We use Cookies to enhance the functionality of our website and improve user experience.</li> </br> <li>You can decline Cookies or adjust settings through your browser settings.</li></ul> </br> <p><strong>*Changes and Updates*</strong></p> </br> <p>Our security policy may be periodically updated in compliance with the legislation of the Republic of Azerbaijan. We recommend checking this page regularly to stay informed about updates. </p> </br> <p>If you have any additional questions, feel free to contact us.</p>",
            cookieDesc: 'Our website uses cookies to improve user experience. To accept the use of cookies, click "Accept," otherwise select "Reject." For more detailed information, we recommend reading the <a href="/privacypolicy">Privacy Policy</a> page.',
            accept: "Accept",
            reject: "Reject",
            mart:"March 8",
            martDesc:"The most beautiful perfumes for you are here!",
            explore:"DISCOVER",
            newProducts:"NEW PRODUCTS",
            bannerMan:"Perfumes for men",
            bannerWoman:"Perfumes for women",

            review:"Leave a review",
            mehsuluqiymetlendir:"Rate the product:",
            gonder:"Send ",
            mesajiniz:"Your message",
            star:"Star",
            ilkRey:"Be the first to review </br> – the stars are waiting for you!" ,

            catdirilmaUnvan: "Delivery Address",
            inputP: "Enter the delivery address"
                  
                  
              

        },




        "ru":{
            home:"ГЛАВНАЯ СТРАНИЦА",
            product:"ПАРФЮМЕРИЯ",
            about:"О НАС",
            blog:"БЛОГ",
            contact:"СВЯЗАТЬСЯ С НАМИ",
            wishlist:"СПИСОК ПОЖЕЛАНИЙ",
            emptywishlist:"Ваш список желаний пуст.",
            cart:"Корзина",
            total:"Общая сумма",
            emptycart:"Ваша корзина пуста.",
            order:"Заказ",
            cartitems:"Товары в вашей корзине",
            productName:"Продукт",
            productName1:"Название продукта",
            quantity:"Количество",
            price:"Цена",
            view:"Вид",
            delete:"Удалять",
            readMore:"Подробнее",
            addToCart:"В корзину",
            address:"Адрес",
            phone:"Телефон",
            email:"Электронная почта",
            copyright:"Все права защищены.",
            man:"Мужской парфюм",
            woman:"Женский парфюм",
            unisex:"Унисекс духи",
            brand:"Бренды",
            all:"Все",
            category:"Категории",
            dis:"СКИДКА",
            brand1:"Бренд",
            volume:"Объем",
            accord:"Aккорд",
            accord1:"Aккорды",
            min:"Мин",
            max:"Макс",
            not:"Hоты",
            readMore:"Более",
            ml:"МЛ",
            sort:"Сортировать по:",
            desc:"Описание",
            pdetails:"ХАРАКТЕРИСТИКИ",
            reviews:"Обзоры",
            order:"Заказ",
            billing:"Детали оплаты",
            about1:"О НАС",
            firstName:"Имя",
            lastName:"Фамилия",
            phone:"Телефон",
            email:"Электронная почта",
            delivery:"Способ доставки :",
            radio1:"Купите в магазине",
            radio2:"Доставка по адресу",
            radioinput:"Адрес",
            orderNote:"Примечание к заказу",
            orderP:"Примечания к вашему заказу, например, особые примечания по доставке.",
            product1:"Продукт",
            lastOrder:"Подтвердите свой заказ",
            yourOrder:"Ваш заказ",
            sort1:"A-З",
            sort2:"З-A",
            sort3:"Цена (Низкий > Высокий)",
            sort4:"Цена (Высокий > Низкий)",
            result:"Результат",
            view:"Вид",
            loading:"Загрузка...",
            search:"Поиск...",
            notfound:"Товар не найден",
            contactAddress:"Чинар Плаза, проспект Гейдара Алиева, Баку, Азербайджан",
            dis:"СКИДКИ",
            aboutTitle:"Компания MyParfumes LLC специализируется на покупке и продаже духов, одеколонов и парфюмерной продукции.",
            aboutDesc:"Мы — компания, которая с 2018 года с любовью и вниманием работает для вас, чтобы каждый клиент находил не только качественные товары, но и сервис, достойный доверия. С первых дней мы приглашаем в свою команду только опытных специалистов, чтобы предоставлять нашим клиентам высокий уровень обслуживания. </br> </br>  Работая исключительно с официальными поставщиками, мы гарантируем абсолютную прозрачность и надёжность информации о каждом продукте, который вам понравится. Только оригинальная парфюмерия от известных мировых брендов — всё, что может покорить и вдохновить. </br> </br>  Наше особое отношение к покупателям помогает нам лучше понимать потребности азербайджанского рынка. Благодаря вашему доверию и поддержке мы всегда привозим в Азербайджан актуальную и востребованную продукцию, которая находится на пике парфюмерной моды. Мы вместе с вами формируем парфюмерные тренды и создаем моду на ароматы, подчеркивая стиль и индивидуальность каждого. </br> </br>  Ваш выбор вдохновляет нас покорять новые вершины в мире парфюмерии и дарит желание каждый день становиться ещё лучше, ближе и ценнее для вас. Спасибо, что вы с нами!",
            searchResult:"Результат поиска :",
            about2:"О нас",
            contact1:"Связаться с нами",
            addToCart1:"Добавлен",
            terms:"Условия и положения",
            terms1:"Политика безопасности",
            terms2:"Политика безопасности",
            allBrand:"Все бренды ",
            payment:"Выберите способ оплаты :",
            payment1:"Наличный расчет",
            payment2:"Онлайн-оплата",
            payment3:"Полная оплата",
            payment4:"Оплата специальной картой рассрочки на сайт",
            payment5:"мес",
            orderSuccess:"Ваш заказ зарегистрирован.",
            welcome:"Добро пожаловать !",
            promoSuccess:"Промокод применён ",
            promoClick:"Применить",
            promoDis:"Введите промокод, чтобы получить скидку.",
            promoErr:"Промокод неверный.",
            original:"Оригинальная Парфюмерия",
            hours: "Рабочие часы",
            express: "Экспресс доставка",
            filial1: "Склад (Экспресс)",
            filial2: "MyShops филиал в Gənclik Mall",
            filial3: "MyShops филиал в Crescent Mall",
            filial4: "MyShops филиал на Бюльбюль",
            filial5: "MyShops филиал в Сумгаите",
            addFilial: "Склад (выход из станции метро Улдуз)",
            addFilial1: "Торговый центр Gənclik Mall, этаж -1",
            addFilial2: "Торговый центр Crescent Mall, этаж 3",
            addFilial3: "Бюльбюль проспект, 38a",
            addFilial4: "Город Сумгайыт, улица Узейира Гаджибейова, 2",
            during: "В течение дня",
            promoErr1:"Срок действия промокода истек.",
            disResult:"до окончания товара",
            dis1:"Скидки",
            say:"Товара нет в наличии",
            disTitle:"Новый парфюм, большая скидка!",
            searchFilter:"Поиск по фильтру",
            notResult:"Результаты поиска не найдены :",
            notResultDesc:"Однако, следующие коллекции парфюмерии могут подойти вашему вкусу и предпочтениям.",
            oneClick:"Купите одним кликом",
            termsDesc: "<p> Согласно действующему законодательству Азербайджанской Республики, парфюмерно-косметическая продукция не подлежит возврату или обмену, если она качественная. Это правило применяется по причинам личной гигиены и безопасности. </p>  </br>  <p> Однако в следующих случаях возврат или обмен товара возможен:  </p> </br> <ol><li> <strong> *Заводской дефект*</strong> – Если товар имеет производственный дефект, покупатель может его вернуть или обменять на аналогичный товар.</li> </br>  <li> <strong> *Неправильная доставка товара*</strong> – Если был отправлен товар, отличающийся от заказанного, он может быть возвращен в оригинальной упаковке и в неиспользованном состоянии.</li> </br>  <li> <strong> *Истечение срока годности товара*</strong> – Товары с истекшим сроком годности на момент покупки могут быть возвращены.</li>  </ol> </br> <p> Для возврата или обмена товара необходимо выполнение следующих условий:</p>  </br> <ul><li> Товар должен быть в оригинальной упаковке и в неиспользованном состоянии. </li> </br> <li>Необходимо предоставить чек или электронный счет о покупке.</li> </br> <li>Запрос на возврат или обмен должен быть сделан в течение <strong>*14 дней*</strong> с момента покупки.</li></ul> </br> <p> Если у вас возникнут дополнительные вопросы по поводу возврата или обмена товара, вы можете связаться с нами. </p>  </br>   <p> <strong>*Примечание:*</strong> В соответствии с требованиями законодательства, наша политика возврата основана на соответствующих правилах и нормативных актах и может быть изменена в любое время. </p>",
            privacyDesc: "<p>Мы придаем большое значение обеспечению безопасности персональных и платежных данных наших клиентов. Все транзакции и передачи данных на нашем сайте защищены в соответствии с современными стандартами безопасности. </p> </br> <p><strong>Защита данных</strong></p> </br> <ul><li>Личные данные, собранные на нашем сайте (имя, фамилия, контактный номер, email и др.), не передаются третьим лицам и используются исключительно для предоставления услуг.</li> </br> <li>Данные, вводимые при оплате, защищены с помощью технологии SSL-шифрования и обрабатываются напрямую сертифицированными платежными системами.</li></ul> </br> <p><strong>Ответственность пользователя</strong></p> </br> <ul><li>Пользователи не должны передавать свои учетные данные (логин, пароль) третьим лицам.</li> </br> <li>Если вы заметили подозрительную активность, немедленно свяжитесь с нами.</li></ul> </br> <p><strong>Cookies и аналитика</strong></p> </br> <ul><li>Мы используем Cookies для повышения функциональности нашего сайта и улучшения пользовательского опыта.</li> </br> <li>Вы можете отказаться от использования Cookies или изменить настройки через настройки браузера.</li></ul> </br> <p><strong>*Изменения и обновления*</strong></p> </br> <p>Наша политика безопасности может периодически обновляться в соответствии с законодательством Азербайджанской Республики. Мы рекомендуем регулярно проверять эту страницу, чтобы быть в курсе изменений. </p> </br> <p>Если у вас есть дополнительные вопросы, свяжитесь с нами.</p>",
            cookieDesc: 'Наш сайт использует cookies для улучшения пользовательского опыта. Для согласия с использованием cookies нажмите «Принять», в противном случае выберите «Отказать». Для получения более подробной информации рекомендуем прочитать страницу <a href="/privacypolicy">Политики конфиденциальности</a>.',
            accept: "Принять",
            reject: "Отказать",
            mart:"8 Марта",
            martDesc:"Самые красивые ароматы для вас здесь!",
            explore:"Открой для себя",
            newProducts:"НОВЫЕ ПРОДУКТЫ",
            bannerMan:"Мужской парфюм",
            bannerWoman:"Женский парфюм",

            review:"Оставить отзыв",
            mehsuluqiymetlendir:"Оцените товар:",
            gonder:"Отправить ",
            mesajiniz:"Ваше сообщение",
            star:"Звезда",
            ilkRey:"Оставьте первый отзыв </br> – звёзды ждут вас!",

            catdirilmaUnvan: "Адрес доставки",
            inputP: "Укажите адрес доставки"
        }
    }

    export default translations ;